// Enhance native validation only; Shopify owns submission, spam protection and feedback.
class SzpontyContactForm extends HTMLElement {
  connectedCallback() {
    this.events?.abort();
    this.events = new AbortController();
    const { signal } = this.events;
    this.addEventListener('invalid', (event) => {
      const field = event.target;
      if (!field.dataset.requiredMessage) return;
      const message = field.validity.valueMissing
        ? field.dataset.requiredMessage
        : field.dataset.invalidMessage || field.dataset.requiredMessage;
      field.setCustomValidity(message);
      field.setAttribute('aria-invalid', 'true');
      const error = this.querySelector(`[id="${field.id}-error"]`);
      if (error) {
        error.textContent = message;
        error.hidden = false;
      }
    }, { capture: true, signal });
    this.addEventListener('input', (event) => {
      const field = event.target;
      if (!field.dataset.requiredMessage) return;
      field.setCustomValidity('');
      field.removeAttribute('aria-invalid');
      const error = this.querySelector(`[id="${field.id}-error"]`);
      if (error) error.hidden = true;
    }, { signal });
  }

  disconnectedCallback() {
    this.events?.abort();
  }
}

if (!customElements.get('szponty-contact-form')) {
  customElements.define('szponty-contact-form', SzpontyContactForm);
}
